import { render } from "./TicketMessages.vue?vue&type=template&id=64a1684a&scoped=true"
import script from "./TicketMessages.vue?vue&type=script&lang=ts"
export * from "./TicketMessages.vue?vue&type=script&lang=ts"

import "./TicketMessages.vue?vue&type=style&index=0&id=64a1684a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64a1684a"

export default script